import _ from 'lodash';

export const isLocal = () => /local\.dev\.manage\.rackspace\.com/i.test(global.location.origin);
export const isDev = () => /\/dev\.manage\.rackspace\.com/i.test(global.location.origin);
export const isProd = () => /\/manage\.rackspace\.com/i.test(global.location.origin);

export const env = () => _.get(_.find([
  [isLocal, 'local'],
  [isDev, 'dev'],
  [isProd, 'prod']
], ([criteria]) => criteria()), 1);

const globalAudience = () => global.isRacker ? 'racker' : 'customer';
const locationAudience = () => (/\/racker($|\/)/gi).test(`${global.location.pathname}`) ? 'racker' : 'customer';

export const debounceDelay = () => 200;
export const copiedLabelDelay = () => 1000;
export const audience = () => _.isBoolean(global.isRacker) ? globalAudience() : locationAudience();
export const isRacker = () => (audience() === 'racker');

export const baseUrl = () => (isLocal() ? 'https://dev.manage.rackspace.com' : global.location.origin);

export const componentMaturity = () => ({
  level: {
    deprecated: 'fatal',
    pre: 'none',
    initial: 'none',
    unstable: 'none',
    feedback: 'none',
    stable: 'none',
    proven: 'none'
  }
});